import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import { GetKey } from "../../../Helpers/GetKey";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import FiltroDashboard from "../../Finanzas/Dashboard/FiltroDashboard";
import { useBox } from "../../Finanzas/Helper/useBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';
import FiltroFiscal from "../FiltroFiscal";
import { InvoiceTable } from "./InvoiceTable";
import { AnaliticaTable } from "./AnaliticaTable";
import { AutorizarModificacionModal } from "./AutorizarModificacionModal";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const puede_autorizar = ["9035", "8919", "9013"];

export const ConciliacionIngresosScreen = () => {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [tabla, setTabla] = useState();
    const [botones, setBotones] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [boxstate, setBoxState] = useBox();
    const [titulo, setTitulo] = useState('CONCILIACION DE INGRESOS');
    const { idempleado } = useSelector((state) => state.usuario);
    console.log(idempleado)
    const [resumen, setResumen] = useState({
        origen: '',
        cargos: 0,
        abonos: 0,
        diferencia: 0,
        registros: 0,
        importe: 0
    });
    const location = useLocation();
    const reporte =
    location.state?.reporte ||
    (location.pathname.includes("Analitica") ? "A" :
     location.pathname.includes("Invoice") ? "I" : null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        onExecute(boxstate.ejercicio, boxstate.periodo, tabla);
    };


    useEffect(() => {
        const fechaActual = new Date();
        const ejercicioActual = fechaActual.getFullYear();
        const mesActual = fechaActual.getMonth() + 1;
        boxstate.ejercicio = ejercicioActual;
        boxstate.periodo = mesActual;
        boxstate.origen = 'I';
        boxstate.tipo = reporte;
        setTabla(reporte);
        onExecute(boxstate.ejercicio, boxstate.periodo, boxstate.tipo, boxstate.origen);
    }, []);

    const onExecute = (ejercicio, periodo, tipo, origen) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            let endpoint = "";

            if (tipo === "I") {
                endpoint = "ConciliacionIngresos/ConciliacionIngresosInvoice";
            } else if (tipo === "A") {
                endpoint = "ConciliacionIngresos/ConciliacionIngresosAnalitica";
            }
            request
                .get(`${endpoint}?ejercicio=${ejercicio}&periodo=${periodo}&origen=${origen}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    if (tipo === "A") {
                        setData(result.analitica);
                        setBotones(result.botones[0]);
                    }
                    else
                        setData(result);

                    console.log(result)
                    setTabla(tipo);
                    const mes = GetMonthNameByNumber(boxstate.periodo).toUpperCase();
                    setTitulo(`CONCILIACION DE INGRESOS ${mes} ${boxstate.ejercicio} - ${tipo == 'I' ? 'INVOICE' : 'ANALITICA'}`);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    // reject(error);
                    Swal.fire("CONCILIACION DE INGRESOS", JSON.stringify(error), "error");
                    // console.log(error)
                    return;
                });
        });
    };

    const onGeneraExcel = (
        ejercicio, periodo, tipo, origen
    ) => {

        setLoader({ ...loader, mostrar: true });
        let endpoint = "";

        if (tipo === "I") {
            endpoint = "ConciliacionIngresos/ImprimirExcelReporteInvoice";
        } else if (tipo === "A") {
            endpoint = "ConciliacionIngresos/ImprimirExcelReporteAnalitica";
        }
        request
            .get(`${endpoint}?ejercicio=${ejercicio}&periodo=${periodo}&origen=${origen}&titulo=${titulo}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FISCAL", JSON.stringify(error), "error");
            });
    };

    const handleAplicar = () => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "Se aplicará la conciliación y no podrá modificarse hasta que se autorice.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, aplicar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
        }).then((result) => {

            if (!result.isConfirmed) return;
            setLoader({ ...loader, mostrar: true });

            const post = {
                ejercicio: boxstate.ejercicio,
                periodo: boxstate.periodo,
                detalle: JSON.stringify(data),
                comentario: "",
                usuario: 0
            };

            // console.log(post)

            request
                .post("ConciliacionIngresos/AplicarConciliacion", post)
                .then((res) => {
                    setLoader({ ...loader, mostrar: false });

                    Swal.fire(
                        "Éxito",
                        "La conciliación se aplicó correctamente",
                        "success"
                    );

                    // opcional: refrescar datos
                    onExecute(boxstate.ejercicio, boxstate.periodo, tabla);
                })
                .catch((err) => {
                    setLoader({ ...loader, mostrar: false });

                    Swal.fire(
                        "Error",
                        JSON.stringify(err),
                        "error"
                    );
                });
        });
    };
    return (
        <PlantillaScreen
            titulo={titulo}
            className_main={1}
            className={"listado-conciliacion-ingresos-mainscreen"}
        >
            <LoaderScreen loader={loader} />
            <div className="listado-conciliacion-ingresos-actions">
                <div
                    className="listado-conciliacion-ingresos-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="listado-conciliacion-ingresos-actions-filtro">
                    <FiltroFiscal
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        esconciliacion={true}
                        reporte={reporte}
                        mostrarOrigen={reporte === 'A'? true : false}
                    />
                </div>
                <div className="listado-conciliacion-ingresos-actions-buttons">
                    <button
                        className="excel"
                        onClick={() =>
                            onGeneraExcel(
                                boxstate.ejercicio,
                                boxstate.periodo,
                                boxstate.tipo,
                                boxstate.origen
                            )
                        }
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    {tabla == "A" && botones?.aplicar && (

                        <button
                            className="aplicar"
                            onClick={() => handleAplicar()}
                        >
                            Aplicar
                        </button>

                    )}
                    {tabla == "A" && botones?.actualizar && puede_autorizar.includes(idempleado) && (
                        <button
                            className="actualizar"
                            onClick={() => handleOpenModal()}
                        >
                            Autorizar Modificacion
                        </button>
                    )}
                </div>
            </div>
            <div className="listado-conciliacion-ingresos-container">
                <div className="listado-conciliacion-ingresos-container-header">

                    <div className="listado-conciliacion-ingresos-container-header-contadores">
                        <b>Origen:</b> <span>{resumen.origen}</span> {" | "}

                        {tabla === "I" ? (
                            <>
                                <b>Importe:</b>{" "}
                                <span>
                                    {FormatMoney(
                                        resumen.importe,
                                        0
                                    )}
                                </span>{" "}
                                {" | "}
                            </>
                        ) : (
                            <>
                                <b>Cargos:</b> <span>{FormatMoney(Math.abs(resumen.cargos), 0)}</span> {" | "}
                                <b>Abonos:</b> <span>{FormatMoney(Math.abs(resumen.abonos), 0)}</span> {" | "}
                                <b>Diferencia:</b> <span>{FormatMoney(Math.abs(resumen.diferencia), 0)}</span> {" | "}
                            </>
                        )}

                        <b>Registros:</b> <span>{resumen.registros}</span>
                    </div>
                </div>
                <div className="listado-conciliacion-ingresos-container-tabla scroll">
                    {tabla == "I" && data ? (
                        <InvoiceTable data={data} onOrigenChange={setResumen} />
                    ) :
                        (
                            <AnaliticaTable data={data} onOrigenChange={setResumen} />
                        )
                    }
                </div>
            </div>
            <AutorizarModificacionModal
                open={openModal}
                onClose={handleCloseModal}
                ejercicio={boxstate.ejercicio}
                periodo={boxstate.periodo}
            />
        </PlantillaScreen>
    );
};

